import AddWebPartImg from "../../../assets/images/Documentations/KPI/AddWebPart.gif";
import WebPartPropertiesImg from "../../../assets/images/Documentations/KPI/UpdateProperties.gif";

function KpiDocumentation() {
  return (
    <>
      <section className="cont-form">
        <div className="container px-0">
          <div className="row privacy">
            <div className="row align-items-center text-center">
              <div className="col-12 ">
                <h1>KPI And Analytics</h1>
              </div>
            </div>

            <div className="col-sm-12 col-lg-12 priv-cont px-0 documentationContent">
              <div className="row">
                <div className="section-heading">
                  <div className="col-md-12 policiesStyle policyFont">
                    <span>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Unlock the
                      power of your SharePoint data with Cloudlas KPI and
                      Analytics WebParts. Effortlessly turn complex information
                      into visually compelling reports, and tailor every detail
                      to fit your business needs using customizable WebPart
                      properties.
                    </span>
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <span className="themeColor">
                      <h5 className="primaryColor">
                        Add KPI components to your SharePoint or Teams channel
                        Tabs
                      </h5>
                    </span>
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <span>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Install
                      the app in your SharePoint site from the store to make the
                      KPI components available in your components gallery. Edit
                      your SharePoint page and search for the components in the
                      components gallery
                    </span>
                  </div>
                  <div
                    className="col-md-12 policiesStyle policyFont"
                    style={{ textAlign: "center" }}
                  >
                    <br />
                    <img src={AddWebPartImg} alt="" />
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <span>
                      <h5 className="primaryColor">
                        Component(WebPart) Properties
                      </h5>
                    </span>
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <span>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; You can
                      control the way reports behave using the properties of the
                      webparts. You might have to refresh the page for the
                      changes to take effect.
                    </span>
                    <br />
                    <br />
                  </div>
                  <div
                    className="col-md-12 policiesStyle policyFont"
                    style={{ textAlign: "center" }}
                  >
                    <img src={WebPartPropertiesImg} alt="" />
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <strong>Data Source List:-</strong>
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <span>
                      Select the SharePoint list to display its data. As you
                      select the list, the fields of the list to be selected in
                      the x and y axis will be available.
                    </span>
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <strong>X-Axis:-</strong>
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <span>Field for the X-axis of the chart.</span>
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <strong> Y-Axis:-</strong>
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <span>
                      Fields for the Y-axis of the chart. Each field will
                      represent its own data in the chart.
                    </span>
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <strong> List filter query:-</strong>
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <span>
                      You can filter the list data using this property. Use the
                      OData filter query format used in SharePoint REST
                      Apis(Basic development knowledge is required). Please read{" "}
                      <a
                        target="_blank"
                        href="https://learn.microsoft.com/en-us/sharepoint/dev/sp-add-ins/use-odata-query-operations-in-sharepoint-rest-requests#odata-query-operators-supported-in-the-sharepoint-rest-service"
                      >
                        Microsoft documentation
                      </a>{" "}
                      for more information on this.
                    </span>
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <strong> Colors:-</strong>
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <span>
                      Colors of the chart elements representing the items. Use
                      hex values comma separated. Chart will take these colors
                      in its order to fill the areas. Chart will take random
                      colors if this property is empty or there are not enough
                      colors mentioned for the items. Eg:- #f8733f,#97f83f
                    </span>
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <strong> Title of the chart:-</strong>
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <span>Property to set a title for the chart.</span>
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <strong> X-Axis and Y-Axis titles:-</strong>
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <span>Properties to set the titles for the axis.</span>
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <strong> Show legend?:-</strong>
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <span>
                      Specifies whether the chart legend should be displayed.
                    </span>
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <strong> Legend Position:-</strong>
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <span>
                      Property to set the position of the legend in the chart
                    </span>
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <strong> Legend Align:-</strong>
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <span>
                      Property to set the alignment of the legend items.
                    </span>
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <strong> Is Stacked?:-</strong>
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br />
                    <span>
                      Specifies whether the items in the bar chart are displayed
                      as stacked. (Only applicable to Bar chart)
                    </span>
                  </div>
                  <div className="col-md-12 policiesStyle policyFont">
                    <br /> <br /> <br />
                    <span>
                      <i>
                        If you need further assistance or have any questions,
                        please don't hesitate to reach out to our{" "}
                        <a href="mailto:support@cloudlas.com">support team</a>.
                        They are available to help you with any issues or
                        concerns you may have. Please reach out to our{" "}
                      </i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default KpiDocumentation;
